import { createStore } from 'redux';
import reducer from './reducers';
import userManager from "./utils/userManager";
import { loadUser } from "redux-oidc";

const store = createStore(reducer);
loadUser(store, userManager);

export default store



// WEBPACK FOOTER //
// ./src/store.js